import { DocumentCitationStyle, DocumentLanguage } from './document.types';

export const CITATION_LIST_FIELD = 'citationList';
export const SHORTCUT_LIST_FIELD = 'shortcutList';
export const FOOTNOTES_OFFSET_FIELD = 'footnotesOffset';

export const DocumentLanguageLabels = {
    [DocumentLanguage.CZ]: '🇨🇿 Čeština',
    [DocumentLanguage.SK]: '🇸🇰 Slovenština',
};

export const DocumentCitationStyleLabels = {
    [DocumentCitationStyle.APA7]: 'APA 7',
    [DocumentCitationStyle.ISO690_2011_Harvard]: 'ISO 690:2011 (Harvard)',
    [DocumentCitationStyle.ISO690_2011_Vancouver]: 'ISO 690:2011 (Vancouver)',
    [DocumentCitationStyle.ISO690_2011_Footnote]: 'ISO 690:2011',
    [DocumentCitationStyle.ISO690_2022_Harvard]: 'ISO 690:2022 (Harvard)',
    [DocumentCitationStyle.ISO690_2022_Vancouver]: 'ISO 690:2022 (Vancouver)',
    [DocumentCitationStyle.ISO690_2022_Footnote]: 'ISO 690:2022',
};
